export default __webpack_public_path__ + "static/media/August2021.cc076dee.png";